import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './TutorialVideosSidebar.css';

export function TutorialVideosSidebar({ currentCategory, onCategoryChange, categories = [], videos = [] }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Use props if provided (for admin context), otherwise use URL params (for main tutorial videos page)
  const activeTab = currentCategory || (searchParams.get('tab') || (categories.length > 0 ? categories[0]?.id : 'getting-started'));

  const handleTabChange = onCategoryChange || ((tabId) => {
    // Default navigation for main tutorial videos page
    const newSearch = tabId === 'all' ? '' : `?tab=${tabId}`;
    navigate(`/learn/tutorial-videos${newSearch}`);
  });

  // Use real categories from props, or fallback to hardcoded ones if not provided
  const displayCategories = categories.length > 0
    ? categories.map(category => ({
        id: category.id,
        label: category.name,
        count: videos.filter(video => video.categoryId === category.id).length
      }))
    : [
        { id: 'getting-started', label: 'Getting Started', count: 15 },
        { id: 'workspace', label: 'Workspace', count: 4 },
        { id: 'ai-features', label: 'AI Features', count: 5 },
        { id: 'deployment', label: 'Deployment', count: 2 },
        { id: 'advanced', label: 'Advanced', count: 1 },
      ];

  return (
    <div className="tutorial-videos-sidebar-content">
      <nav className="sidebar-navigation">
        {displayCategories.map((category) => (
          <button
            key={category.id}
            className={`sidebar-tab ${activeTab === category.id ? 'active' : ''}`}
            onClick={() => handleTabChange(category.id)}
          >
            <span className="tab-label">{category.label}</span>
            <span className="tab-count">{category.count}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}